import React, { Fragment, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Packages
import { Descriptions, Divider, Modal, Space, Tag } from 'antd';

// Actions
import { open_log_modal, set_log_info } from '../../actions/logsActions';

// Utils
import { setLogTypeColor } from '../../utils/logsTypes';

const LogInfo = () => {
	const { log_modal_open, log_info } = useSelector(state => state.logs);

	const dispatch = useDispatch();

	const modalContentRef = useRef(null);

	useEffect(() => {
		if (log_modal_open) {
			setTimeout(() => {
				if (modalContentRef.current) {
					modalContentRef.current.scrollTop = 0; // Ensure the scroll starts at the top
				}
			}, 100); // Wait 100ms to ensure the modal is fully rendered
		}
	}, [log_modal_open]); // Runs only when the modal opens

	const onCancel = () => {
		dispatch(open_log_modal(false));
		dispatch(set_log_info({}));
	}

	return (
		<Modal
			title='Información de Log'
			centered
			open={log_modal_open}
			onCancel={onCancel}
			width={800}
			footer={null}
		>
			<Space style={{ maxHeight: '62vh', overflowY: 'auto', overflowX: 'hidden'}} ref={modalContentRef} direction='vertical'>
				<Descriptions
					size='small'
					column={1}
					items={[
						{
							key: 'title',
							label: 'Título',
							children: log_info.title
						},
						{
							key: 'log_type',
							label: 'Tipo de Log',
							children: <Tag color={setLogTypeColor(log_info.log_type)}>{log_info.log_type}</Tag>
						},
						{
							key: 'process_id',
							label: 'ID de Proceso',
							children: log_info.process_id
						},
						{
							key: 'status',
							label: 'Estado',
							children: log_info.status
						},
						{
							key: 'process_status',
							label: 'Estado de Proceso',
							children: log_info.process_status
						}
					]}
				/>
				<Divider />
				<Descriptions
					title='Local'
					size='small'
					column={1}
					items={[
						{
							key: 'is_complete',
							label: 'Completo',
							children: log_info.is_complete?.toString(),
						},
						{
							key: 'local_id',
							label: 'ID Local',
							children: log_info.local_id,
						},
						{
							key: 'local_date',
							label: 'Fecha Local',
							children: new Date(log_info.local_date).toLocaleString('es-MX', { hour12: true }),
						}
					]}
				/>
				<Divider />
				<Descriptions
					title='Organización'
					size='small'
					column={1}
					items={[
						{
							key: 'module',
							label: 'Módulo',
							children: log_info.module,
						},
						{
							key: 'submodule',
							label: 'Submódulo',
							children: log_info.submodule,
						},
						{
							key: 'configuration',
							label: 'Configuración de Submódulo',
							children: log_info.configuration,
						},
						{
							key: 'cycle',
							label: 'Ciclo',
							children: log_info.cycle,
						}
					]}
				/>
				{[log_info.route, log_info.headers, log_info.preheaders, log_info.traceback].some(value => value != null) &&
					<Fragment>
						<Divider />
						<Descriptions
							title='Request'
							size='small'
							column={1}
							items={[
								...(log_info.route ? [{
									key: 'route',
									label: 'Ruta',
									children: (
										<pre style={{ marginTop: 4, marginBottom: 0, width: '97%', overflowX: 'auto', whiteSpace: 'pre-wrap' }}>
											{log_info.route}
										</pre>
									),
								}] : []),
							
								...(log_info.headers ? [{
									key: 'headers',
									label: 'Headers',
									children: (
										<pre style={{ marginTop: 4, marginBottom: 0, width: '97%', overflowX: 'auto', whiteSpace: 'pre-wrap' }}>
											{JSON.stringify(log_info.headers, null, 2)}
										</pre>
									),
								}] : []),
							
								...(log_info.preheaders ? [{
									key: 'preheaders',
									label: 'Preheaders',
									children: (
										<pre style={{ marginTop: 4, marginBottom: 0, width: '97%', overflowX: 'auto', whiteSpace: 'pre-wrap' }}>
											{JSON.stringify(log_info.preheaders, null, 2)}
										</pre>
									),
								}] : []),
							
								...(log_info.traceback ? [{
									key: 'traceback',
									label: 'Traceback',
									children: (
										<pre style={{ marginTop: 4, marginBottom: 0, width: '97%', overflowX: 'auto', whiteSpace: 'pre-wrap' }}>
											{log_info.traceback}
										</pre>
									)
								}] : []),
							]}
						/>
					</Fragment>
				}
			</Space>
		</Modal>
	)
}

export default LogInfo;
